import { parse, format, isDate, isValid } from "date-fns";
import { enUS } from "date-fns/locale";
import { dateFormats } from "../config/constants";

export const convertDate = (date: string) => {
  try {
    if (date == "TBA") return date;
    return format(parse(date, "MM-dd-yyyy", new Date()), "eeee, MMM dd, yyyy", {
      locale: enUS,
    });
  } catch (error) {
    return date;
  }
};

export const convertShortDate = (
  date: string,
  formatStr: string = "MM/dd/yy"
) => {
  let parsedDate: Date | string = "TBD";

  try {
    if (!date) return parsedDate;
    const isMarker = ["TBA", "TBD"].includes(date?.toUpperCase());
    if (isMarker) return (parsedDate = date?.toUpperCase());

    let validDate = "" as unknown as Date;
    for (const format of dateFormats) {
      let parsed = parse(date, format, new Date());
      const isValidDate = isValid(parsed);
      if (isValidDate) {
        validDate = parsed;
        break;
      }
    }

    if (validDate) parsedDate = format(validDate, formatStr, { locale: enUS });
  } catch (error) {
    console.log(error);
  } finally {
    return parsedDate;
  }
};

export const convertISODate = (date: string) => {
  if (date === "TBA") {
    return date;
  }
  return format(new Date(date), "MM/dd/yy 'at' hh:mm a", {
    locale: enUS,
  });
};

export const convertTime = (time: string) => {
  try {
    if (time == "TBA") return time;
    return format(
      parse(
        `${format(new Date(), "yyyy-MM-dd")} ${time}`,
        "yyyy-MM-dd HH:mm",
        new Date()
      ),
      "hh:mm aa",
      { locale: enUS }
    );
  } catch (error) {
    return time;
  }
};
